import type { ReactNode } from 'react';
import { SettingsPageLayout } from '@/platform/layout';
import type { SitePageLayoutProps } from '@/platform/layout/SitePageLayout';
import { MarketplaceSubNav } from './MarketplaceSubNav';

type MarketplacePageFrameProps = Pick<
  SitePageLayoutProps,
  'title' | 'description' | 'back' | 'actions' | 'toolbar' | 'alerts'
> & {
  children: ReactNode;
};

/** Standard marketplace shell: settings layout + subnav. */
export function MarketplacePageFrame({ children, ...page }: MarketplacePageFrameProps) {
  return (
    <SettingsPageLayout {...page} bare>
      <MarketplaceSubNav />
      {children}
    </SettingsPageLayout>
  );
}
